(() => {
  const html = document.documentElement;
  const drawer = document.getElementById('InfoDrawer');
  const btn = document.querySelector('.js-info-drawer-toggle');
  if (!drawer || !btn) return;

  const open = () => {
    html.classList.remove('is-mobile-menu-open');
    document.querySelectorAll('.left-sidebar__mobileMenuToggle').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Menu';
    });
    html.classList.add('is-info-drawer-open');
    btn.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  };

  const close = () => {
    html.classList.remove('is-info-drawer-open');
    btn.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  };

  // click toggle (mobile + desktop)
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    html.classList.contains('is-info-drawer-open') ? close() : open();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-info-drawer-close]')) return;

    e.preventDefault();
    close();
  });

  const desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 991px)');
  const canUseDesktopHover = () => desktopHoverQuery.matches;

  // Desktop hover support only. On mobile widths, click is the only trigger.
  btn.addEventListener('mouseenter', () => {
    if (canUseDesktopHover()) open();
  });
  drawer.addEventListener('mouseenter', () => {
    if (canUseDesktopHover()) open();
  });
  btn.addEventListener('mouseleave', () => {
    if (!canUseDesktopHover()) return;

    // give time to move into drawer
    setTimeout(() => {
      if (canUseDesktopHover() && !drawer.matches(':hover') && !btn.matches(':hover')) close();
    }, 80);
  });
  drawer.addEventListener('mouseleave', () => {
    if (canUseDesktopHover()) close();
  });

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
